import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import dayjs from 'dayjs';
import moment from 'moment';
import { UtilityService } from '../utility_functions/utility_functions.service';
@Injectable()
export class FormBuilderService {

    constructor(private _formBuilder: FormBuilder, private _utilityService: UtilityService) { }

    constructFormGroupFromConfig(checkListFormArray: any[]): FormGroup {
        let formFields = {};
        checkListFormArray?.filter((elements: any) => elements.field_type !== 'HEADER').forEach((field: any) => {
            let currentFormField = {};
            let validators = [];
            if (!field?.is_dependent) {
                if (field?.is_required) {
                    validators = [...validators, Validators.required];
                }
                if (!this._utilityService.isEmptyOrUndefined(field?.max_value)) {
                    validators = [...validators, Validators.max(field?.max_value)];
                }
                if (!this._utilityService.isEmptyOrUndefined(field?.min_value)) {
                    validators = [...validators, Validators.min(field?.min_value)];
                }
                if (field?.regex_value) {
                    validators = [...validators, Validators.pattern(field?.regex_value)];
                }
            }
            if (field?.field_type === 'DATE') {
                currentFormField = {
                    [field.field_name]: [{
                        value: field?.field_value ? moment(dayjs(field?.field_value, 'YYYY-MM-DD').format()) : field?.field_value,
                        disabled: field?.read_only
                    }, validators]
                };
            } else if (field?.field_type === 'TIME') {
                currentFormField = {
                    [field.field_name]: [{
                        value: field?.field_value ? moment(dayjs(field?.field_value, 'HH:mm:ss').format(), this._utilityService.timeFormat) : field?.field_value,
                        disabled: field?.read_only
                    }, validators]
                };
            } else if (field?.field_type === 'DATETIME') {
                currentFormField = {
                    [field.field_name]: [{
                        value: field?.field_value ? moment(dayjs(
                            this._utilityService.convertBackFromUTC(field?.field_value, 'YYYY-MM-DD HH:mm:ss', 'datetime')
                            , this._utilityService.dateTimeFormat
                        ).format()
                        ) :
                            field?.field_value,
                        disabled: field?.read_only
                    }, validators]
                };
            } else if (['MULTI_ITEM', 'MULTI_IMAGE'].includes(field?.field_type)) {
                currentFormField = {
                    [field.field_name]: [{
                        value: field?.field_value ? field?.field_value.split(',') :
                            field?.field_value,
                        disabled: field?.read_only
                    }, validators]
                };
            }
            else if (field?.field_type === 'SINGLE_ITEM') {
                currentFormField = {
                    [field?.field_name]: [{
                        value: field?.field_value ? field?.field_value : ((field?.default_option === true && field?.field_options?.length > 0) ? field?.field_options[0] : ''),
                        disabled: field?.read_only
                    }, validators]
                };
            }
            else {
                currentFormField = {
                    [field.field_name]: [{
                        value: field?.field_value ? field?.field_value : null,
                        disabled: field?.read_only
                    }, validators]
                };
            }
            formFields = { ...formFields, ...currentFormField };
        });
        return this._formBuilder.group(formFields);
    }
}
